/**
* MMap object
**/

import $ from "jquery"
import { trace } from "./helpers.js"


class MMap {

  // ## Constructor ###
  constructor( options ) {
    // trace ("new map object", options);
    this.$map = options.$map;
    this.$mapData = options.$mapData;
    this.id = options.id;
    this.markersArr = [];
    this.bounds = new google.maps.LatLngBounds();
    this.startPoint = new google.maps.LatLng(52.229676, 21.012229);
    this.geocoder = new google.maps.Geocoder();
    this.markersLimit = 30;
    this.clusterGridSize = 40;
    this.dataRecordSelector = '.gmplacemark-map-record';
    this.initializeMap();
    this.initPlacemarks();
    this.fitBounds();
  }

  getPlacemarkIcon() {
    return '/local/images/placemark.png';
  }
  getPlacemarkIconHover() {
    return '/local/images/placemark_hover.png';
  }

  getMapOptions() {
    return {
      zoom: 14,
      scrollwheel: false,
      center: this.startPoint,
      disableDefaultUI: false,
      styles: this.getMapStyles() // scroll down ;)
    };
  }

  // init map object
  initializeMap() {
    // trace("initialize map", document.getElementById( this.id ));
    this.map = new google.maps.Map( document.getElementById( this.id ), this.getMapOptions() );

  }

  // init placemarks from $mapData
  initPlacemarks() {
    this.$mapData.find(this.dataRecordSelector).each( this.initPlacemark.bind(this) );
    // cluster markers?
    if (this.markersArr.length >= this.markersLimit) {
        let mcp = {
                    maxZoom: 16,
                    gridSize: this.clusterGridSize,
                    imagePath: '/local/images/m'
                };
        this.markerCluster = new MarkerClusterer(this.map, this.markersArr, mcp);
    }
  }

  // init Placemark from DOM object
  initPlacemark(index, el) {
    let $p = $(el);
    let lat = parseFloat($p.data('lat'));
    let lng = parseFloat($p.data('lng'));    
    let content = $p.html();
    if (!lat || !lng) {
      return false;
    }
    // trace("lat", lat, "lng", lng);
    let latlng = new google.maps.LatLng(lat, lng);
    let marker = new google.maps.Marker({
      position: latlng,
      map: this.map,
      icon: this.getPlacemarkIcon()
    });

    marker.infoWindow = new google.maps.InfoWindow({
        content: content,
        maxWidth: 250
    });
    // add event listeners
    marker.addListener('click', ()=>{
      marker.infoWindow.open(this.map, marker);
      return false;
    });
    marker.addListener('mouseover', ()=>{
      marker.setIcon( this.getPlacemarkIconHover() );
    });
    marker.addListener('mouseout', ()=>{
      marker.setIcon( this.getPlacemarkIcon() );
    });

    this.bounds.extend(latlng);
    this.markersArr.push(marker);

  }

  // fit Bounds
  fitBounds() {
    if (this.markersArr.length < 1) {
      // trace("fir bounds makes no sense");
      return false;
    } else if (this.markersArr.length == 1) {
      // only one marker - center on it
      let latlng = this.markersArr[0].getPosition();
      this.map.setCenter(latlng);
    } else {
      this.map.fitBounds( this.bounds );
    }
  }


  // ### Map Styles ###
  getMapStyles() {
    return [
    {
        "featureType": "all",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "saturation": 36
            },
            {
                "color": "#333333"
            },
            {
                "lightness": 40
            }
        ]
    },
    {
        "featureType": "all",
        "elementType": "labels.text.stroke",
        "stylers": [
            {
                "visibility": "on"
            },
            {
                "color": "#ffffff"
            },
            {
                "lightness": 16
            }
        ]
    },
    {
        "featureType": "all",
        "elementType": "labels.icon",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "administrative",
        "elementType": "geometry.fill",
        "stylers": [
            {
                "color": "#fefefe"
            },
            {
                "lightness": 20
            }
        ]
    },
    {
        "featureType": "administrative",
        "elementType": "geometry.stroke",
        "stylers": [
            {
                "color": "#fefefe"
            },
            {
                "lightness": 17
            },
            {
                "weight": 1.2
            }
        ]
    },
    {
        "featureType": "administrative.land_parcel",
        "elementType": "geometry.fill",
        "stylers": [
            {
                "lightness": "0"
            }
        ]
    },
    {
        "featureType": "landscape",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#f5f5f5"
            },
            {
                "lightness": 20
            }
        ]
    },
    {
        "featureType": "poi",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#f5f5f5"
            },
            {
                "lightness": 21
            }
        ]
    },
    {
        "featureType": "poi.park",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#dedede"
            },
            {
                "lightness": 21
            }
        ]
    },
    {
        "featureType": "road.highway",
        "elementType": "geometry.fill",
        "stylers": [
            {
                "color": "#ffffff"
            },
            {
                "lightness": 17
            }
        ]
    },
    {
        "featureType": "road.highway",
        "elementType": "geometry.stroke",
        "stylers": [
            {
                "color": "#ffffff"
            },
            {
                "lightness": 29
            },
            {
                "weight": 0.2
            }
        ]
    },
    {
        "featureType": "road.arterial",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#ffffff"
            },
            {
                "lightness": 18
            }
        ]
    },
    {
        "featureType": "road.local",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#ffffff"
            },
            {
                "lightness": 16
            }
        ]
    },
    {
        "featureType": "transit",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#f2f2f2"
            },
            {
                "lightness": 19
            }
        ]
    },
    {
        "featureType": "water",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#e9e9e9"
            },
            {
                "lightness": 17
            }
        ]
    },
    {
        "featureType": "water",
        "elementType": "geometry.fill",
        "stylers": [
            {
                "color": "#dbdbdb"
            }
        ]
    }
];
  }

}

export default MMap;

